(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const initializePriceOverlays = (source) => {
      if (source.dataset.initialized === 'true') {
        return;
      }

      const section = source.closest('.shopify-section');
      const pageContent = section?.querySelector('.cartello-format-page');

      if (!pageContent) {
        return;
      }

      source
        .querySelectorAll('[data-cartello-format-template]')
        .forEach((priceTemplate) => {
          const searchValue = priceTemplate.dataset.cartelloSearch;
          const formatLink = Array.from(
            pageContent.querySelectorAll('a[href]')
          ).find((link) => {
            const url = new URL(link.href, window.location.origin);

            return (
              url.pathname === '/pages/templates-cartelli-attenti-al-cane' &&
              url.searchParams.get('search') === searchValue
            );
          });

          if (!formatLink || formatLink.querySelector('.cartello-format-price-overlay')) {
            return;
          }

          formatLink.classList.add('cartello-format-link');
          formatLink.append(priceTemplate.content.cloneNode(true));
        });

      source.dataset.initialized = 'true';
    };

    const initializeAllPriceOverlays = (scope = document) => {
      scope
        .querySelectorAll('[data-cartello-format-prices]')
        .forEach(initializePriceOverlays);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllPriceOverlays, {
        once: true
      });
    } else {
      initializeAllPriceOverlays();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllPriceOverlays(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pitchprint-template-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const apiState = window.__pitchPrintCatalogApi || {};

    apiState.tokenPromises ||= new Map();
    apiState.categoryPromises ||= new Map();
    apiState.designDetailsPromises ||= new Map();

    window.__pitchPrintCatalogApi = apiState;

    const postJson = async (url, payload) => {
      const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`PitchPrint request failed: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.error) {
        throw new Error('PitchPrint returned an error');
      }

      return data;
    };

    const getToken = (shop) => {
      if (!apiState.tokenPromises.has(shop)) {
        apiState.tokenPromises.set(
          shop,
          postJson('https://api.pitchprint.io/client/init', {
            userId: 'guest',
            apiKey: shop,
            client: 'sp',
            version: '9.1.0',
            isFrame: true,
            isAdmin: false
          }).then((data) => {
            if (!data.token) {
              throw new Error('PitchPrint token missing');
            }

            return data.token;
          })
        );
      }

      return apiState.tokenPromises.get(shop);
    };

    const parseProductConfig = (product) => {
      if (!product.pitchPrintConfig) {
        return null;
      }

      try {
        const config =
          typeof product.pitchPrintConfig === 'string'
            ? JSON.parse(product.pitchPrintConfig)
            : product.pitchPrintConfig;

        return config && config.designId ? config : null;
      } catch (error) {
        return null;
      }
    };

    const getCategoryDesigns = (categoryId, shop) => {
      const cacheKey = `${shop}:${categoryId}`;

      if (!apiState.categoryPromises.has(cacheKey)) {
        apiState.categoryPromises.set(
          cacheKey,
          getToken(shop)
            .then((token) =>
              postJson('https://api.pitchprint.io/client/fetch-cat-details', {
                id: categoryId,
                token
              })
            )
            .then((response) =>
              response &&
              response.data &&
              Array.isArray(response.data.designs)
                ? response.data.designs
                : []
            )
        );
      }

      return apiState.categoryPromises.get(cacheKey);
    };

    const getDesigns = async (config, product, shop) => {
      const designId = String(config.designId || '');

      if (!designId) {
        return [];
      }

      if (!designId.startsWith('*')) {
        return [
          {
            id: designId,
            title: product.title,
            thumbnail: `https://s3-eu-west-1.amazonaws.com/pitchprint.io/previews/${designId}_1.jpg`
          }
        ];
      }

      return getCategoryDesigns(designId.slice(1), shop);
    };

    const normalizeDimension = (value, unit) => {
      const numericValue = Number.parseFloat(String(value || '').replace(',', '.'));

      if (!Number.isFinite(numericValue) || numericValue <= 0) {
        return null;
      }

      const factors = {
        mm: 1,
        cm: 10,
        in: 25.4,
        inch: 25.4,
        inches: 25.4
      };

      return numericValue * (factors[String(unit || '').toLocaleLowerCase()] || 1);
    };

    const getDesignDetails = (designId) => {
      if (!apiState.designDetailsPromises.has(designId)) {
        apiState.designDetailsPromises.set(
          designId,
          fetch(`https://pitchprint.io/designs/${encodeURIComponent(designId)}`, {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit',
            cache: 'no-cache'
          }).then(async (response) => {
            if (!response.ok) {
              throw new Error(`PitchPrint design request failed: ${response.status}`);
            }

            const design = await response.json();
            const pageData = design.pages?.[0]?.pageData || {};

            return {
              title: design.pages?.[0]?.pageData?.title?.trim() || null,
              revision: response.headers.get('last-modified') || null,
              width: normalizeDimension(pageData.fWidth, design.unit),
              height: normalizeDimension(pageData.fHeight, design.unit)
            };
          })
        );
      }

      return apiState.designDetailsPromises.get(designId);
    };

    const buildProductUrl = (product, designId) => {
      const url = new URL(product.url, window.location.origin);

      if (product.variantId) {
        url.searchParams.set('variant', product.variantId);
      }

      url.searchParams.set('pp_design', designId);
      url.searchParams.set('pp_autostart', '1');
      url.searchParams.set('pp_catalog_flow', '1');

      return `${url.pathname}${url.search}${url.hash}`;
    };

    const createCard = (root, product, design, originalIndex) => {
      const article = document.createElement('article');
      const link = document.createElement('a');
      const imageWrap = document.createElement('div');
      const image = document.createElement('img');
      const content = document.createElement('div');
      const productName = document.createElement('span');
      const designName = document.createElement('h2');
      const action = document.createElement('span');

      article.className = 'pitchprint-catalog__card';
      link.className = 'pitchprint-catalog__link focus-inset';
      link.href = buildProductUrl(product, design.id);

      imageWrap.className = 'pitchprint-catalog__image-wrap';
      image.className = 'pitchprint-catalog__image';
      image.src =
        design.thumbnail ||
        `https://s3-eu-west-1.amazonaws.com/pitchprint.io/previews/${design.id}_1.jpg`;
      image.width = 600;
      image.height = 450;
      image.loading = 'lazy';

      content.className = 'pitchprint-catalog__content';
      productName.className = 'pitchprint-catalog__product';
      productName.textContent = product.title;
      designName.className = 'pitchprint-catalog__design';
      action.className = 'pitchprint-catalog__action';
      action.textContent = root.dataset.action;

      imageWrap.append(image);
      content.append(productName, designName, action);
      link.append(imageWrap, content);
      article.append(link);

      const setTitle = (title, revision) => {
        const resolvedTitle = title || design.title || product.title;

        article.dataset.search =
          `${product.title} ${design.title || ''} ${resolvedTitle}`.toLocaleLowerCase();
        image.alt = `${resolvedTitle} - ${product.title}`;
        designName.textContent = `${root.dataset.modelLabel} ${resolvedTitle}`;

        if (revision) {
          const imageUrl = new URL(image.src);
          imageUrl.searchParams.set('v', revision);
          image.src = imageUrl.href;
        }
      };

      setTitle(design.title);

      const cardRecord = {
        article,
        product,
        design,
        originalIndex,
        width: null,
        height: null,
        setDetails(details) {
          this.width = details.width;
          this.height = details.height;
          setTitle(details.title, details.revision);

          if (Number.isFinite(this.width) && Number.isFinite(this.height)) {
            article.dataset.widthMm = String(this.width);
            article.dataset.heightMm = String(this.height);
            article.dataset.areaMm = String(this.width * this.height);
          }
        }
      };

      return cardRecord;
    };

    const compareCardsBySize = (firstCard, secondCard) => {
      const firstHasSize =
        Number.isFinite(firstCard.width) && Number.isFinite(firstCard.height);
      const secondHasSize =
        Number.isFinite(secondCard.width) && Number.isFinite(secondCard.height);

      if (firstHasSize !== secondHasSize) {
        return firstHasSize ? -1 : 1;
      }

      if (!firstHasSize) {
        return firstCard.originalIndex - secondCard.originalIndex;
      }

      const areaDifference =
        firstCard.width * firstCard.height -
        secondCard.width * secondCard.height;

      return (
        areaDifference ||
        firstCard.width - secondCard.width ||
        firstCard.height - secondCard.height ||
        firstCard.originalIndex - secondCard.originalIndex
      );
    };

    const applyRelativePlateScale = (cardRecords) => {
      const sizedCards = cardRecords.filter(
        (cardRecord) =>
          Number.isFinite(cardRecord.width) &&
          Number.isFinite(cardRecord.height)
      );
      const areas = sizedCards.map(
        (cardRecord) => cardRecord.width * cardRecord.height
      );

      if (!areas.length) {
        return;
      }

      const minimumArea = Math.min(...areas);
      const maximumArea = Math.max(...areas);
      const logarithmicRange = Math.log(maximumArea) - Math.log(minimumArea);
      const minimumScale = 0.4;
      const scaleRange = 0.6;

      sizedCards.forEach((cardRecord) => {
        const area = cardRecord.width * cardRecord.height;
        const relativeSize =
          logarithmicRange > 0
            ? (Math.log(area) - Math.log(minimumArea)) / logarithmicRange
            : 1;
        const visualScale = minimumScale + scaleRange * relativeSize;

        cardRecord.article.style.setProperty(
          '--pitchprint-plate-scale',
          visualScale.toFixed(4)
        );
        cardRecord.article.dataset.visualScale = visualScale.toFixed(4);
      });
    };

    const loadWithConcurrency = async (items, concurrency, worker, onSettled) => {
      const results = new Array(items.length);
      let index = 0;
      let completed = 0;

      const run = async () => {
        while (index < items.length) {
          const currentIndex = index;
          index += 1;

          try {
            results[currentIndex] = await worker(items[currentIndex]);
          } catch (error) {
            console.warn(
              '[PitchPrint catalog]',
              items[currentIndex].product?.title || items[currentIndex].title,
              error
            );
            results[currentIndex] = [];
          }

          completed += 1;
          onSettled?.(currentIndex, results[currentIndex], completed);
        }
      };

      const workers = Array.from(
        { length: Math.min(concurrency, items.length) },
        () => run()
      );

      await Promise.all(workers);
      return results;
    };

    const formatProgress = (template, current, total) =>
      template
        .replace('__CURRENT__', String(current))
        .replace('__TOTAL__', String(total));

    const updateProgress = (
      progressWrap,
      progress,
      progressLabel,
      template,
      current,
      total
    ) => {
      progressWrap.hidden = false;
      progress.max = Math.max(total, 1);
      progress.value = current;
      progressLabel.textContent = formatProgress(template, current, total);
    };

    const syncCompactBreadcrumb = (breadcrumb) => {
      if (!breadcrumb.classList.contains('site-breadcrumbs--compact')) {
        return;
      }

      const list = breadcrumb.querySelector('.site-breadcrumbs__list');
      const overflow = list?.querySelector('.site-breadcrumbs__overflow');
      const overflowList = overflow?.querySelector(
        '.site-breadcrumbs__overflow-list'
      );

      if (!list || !overflow || !overflowList) {
        return;
      }

      const contentItems = Array.from(
        list.querySelectorAll(':scope > .site-breadcrumbs__item')
      ).filter(
        (item) =>
          !item.classList.contains('site-breadcrumbs__item--home') &&
          !item.classList.contains('site-breadcrumbs__overflow')
      );
      const hiddenItems = contentItems.slice(0, Math.max(contentItems.length - 2, 0));

      contentItems.forEach((item) => {
        item.classList.toggle(
          'site-breadcrumbs__item--compact-hidden',
          hiddenItems.includes(item)
        );
      });

      overflow.hidden = hiddenItems.length === 0;
      overflowList.replaceChildren(
        ...hiddenItems.map((item) => {
          const source = item.querySelector(
            ':scope > .site-breadcrumbs__link, :scope > .site-breadcrumbs__ancestor'
          );
          const overflowItem = document.createElement('li');
          overflowItem.className = 'site-breadcrumbs__overflow-item';

          if (source?.matches('a')) {
            const link = document.createElement('a');
            link.className = 'site-breadcrumbs__overflow-link';
            link.href = source.href;
            link.textContent = source.textContent;
            overflowItem.append(link);
          } else {
            const label = document.createElement('span');
            label.textContent = source?.textContent || '';
            overflowItem.append(label);
          }

          return overflowItem;
        })
      );
    };

    const syncCatalogBreadcrumb = (rawQuery) => {
      const breadcrumb = document.querySelector('[data-catalog-breadcrumb]');
      const list = breadcrumb?.querySelector('.site-breadcrumbs__list');
      const pageItem = list?.querySelector('[data-breadcrumb-page-item]');
      let pageLabel = pageItem?.querySelector('[data-breadcrumb-page-label]');

      if (!breadcrumb || !list || !pageItem || !pageLabel) {
        return;
      }

      const queryLabel = rawQuery.trim().replace(/\s+/g, ' ').slice(0, 80);
      let searchItem = list.querySelector('[data-breadcrumb-search-item]');

      if (queryLabel) {
        if (!pageLabel.matches('a')) {
          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.delete('search');

          const pageLink = document.createElement('a');
          pageLink.className = 'site-breadcrumbs__link site-breadcrumbs__text';
          pageLink.href = `${pageUrl.pathname}${pageUrl.search}${pageUrl.hash}`;
          pageLink.textContent = pageLabel.textContent;
          pageLink.dataset.breadcrumbPageLabel = '';
          pageLabel.replaceWith(pageLink);
          pageLabel = pageLink;
        }

        if (!searchItem) {
          searchItem = document.createElement('li');
          searchItem.className = 'site-breadcrumbs__item';
          searchItem.dataset.breadcrumbSearchItem = '';

          const separator = pageItem
            .querySelector('.site-breadcrumbs__separator')
            ?.cloneNode(true);
          const current = document.createElement('span');
          current.className = 'site-breadcrumbs__current site-breadcrumbs__text';
          current.setAttribute('aria-current', 'page');

          if (separator) {
            searchItem.append(separator);
          }

          searchItem.append(current);
          list.append(searchItem);
        }

        searchItem.querySelector('[aria-current="page"]').textContent = queryLabel;
      } else {
        searchItem?.remove();

        if (pageLabel.matches('a')) {
          const current = document.createElement('span');
          current.className = 'site-breadcrumbs__current site-breadcrumbs__text';
          current.setAttribute('aria-current', 'page');
          current.dataset.breadcrumbPageLabel = '';
          current.textContent = pageLabel.textContent;
          pageLabel.replaceWith(current);
        }
      }

      syncCompactBreadcrumb(breadcrumb);
    };

    const initializeCatalog = async (root) => {
      if (root.dataset.initialized === 'true') {
        return;
      }

      root.dataset.initialized = 'true';

      const productsData = root.querySelector('[data-pitchprint-products]');
      const grid = root.querySelector('[data-pitchprint-grid]');
      const status = root.querySelector('[data-pitchprint-status]');
      const search = root.querySelector('[data-pitchprint-search]');
      const progressWrap = root.querySelector('[data-pitchprint-progress-wrap]');
      const progress = root.querySelector('[data-pitchprint-progress]');
      const progressLabel = root.querySelector('[data-pitchprint-progress-label]');

      if (
        !productsData ||
        !grid ||
        !status ||
        !progressWrap ||
        !progress ||
        !progressLabel
      ) {
        return;
      }

      const initialQuery =
        new URL(window.location.href).searchParams.get('search') || '';

      syncCatalogBreadcrumb(initialQuery);

      if (search) {
        search.value = initialQuery;
      }

      let products = [];

      try {
        products = JSON.parse(productsData.textContent);
      } catch (error) {
        status.textContent = root.dataset.error;
        return;
      }

      const configuredProducts = products
        .map((product) => ({
          product,
          config: parseProductConfig(product)
        }))
        .filter((item) => item.config);

      if (!configuredProducts.length) {
        status.textContent = root.dataset.empty;
        status.hidden = false;
        progressWrap.hidden = true;
        return;
      }

      status.textContent = root.dataset.loading;
      status.hidden = true;
      grid.replaceChildren();

      try {
        const shop = root.dataset.shop;
        const cardRecords = [];
        const pendingEntries = new Map();
        let nextProductIndex = 0;

        updateProgress(
          progressWrap,
          progress,
          progressLabel,
          root.dataset.discovering,
          0,
          configuredProducts.length
        );

        await loadWithConcurrency(
          configuredProducts,
          6,
          async ({ product, config }) => {
            const designs = await getDesigns(config, product, shop);
            return designs.map((design) => ({ product, design }));
          },
          (productIndex, productEntries, completed) => {
            pendingEntries.set(productIndex, productEntries);

            while (pendingEntries.has(nextProductIndex)) {
              const readyEntries = pendingEntries.get(nextProductIndex);
              pendingEntries.delete(nextProductIndex);
              nextProductIndex += 1;

              readyEntries.forEach(({ product, design }) => {
                const cardRecord = createCard(
                  root,
                  product,
                  design,
                  cardRecords.length
                );
                cardRecords.push(cardRecord);
                grid.append(cardRecord.article);
              });
            }

            updateProgress(
              progressWrap,
              progress,
              progressLabel,
              root.dataset.discovering,
              completed,
              configuredProducts.length
            );
          }
        );

        if (!cardRecords.length) {
          status.textContent = root.dataset.empty;
          status.hidden = false;
          progressWrap.hidden = true;
          return;
        }

        const applySearch = (updateUrl = false) => {
          const rawQuery = search ? search.value.trim() : initialQuery.trim();
          const query = rawQuery.toLocaleLowerCase();
          let visibleCount = 0;

          grid.querySelectorAll('.pitchprint-catalog__card').forEach((card) => {
            const visible = !query || card.dataset.search.includes(query);
            card.hidden = !visible;

            if (visible) {
              visibleCount += 1;
            }
          });

          status.textContent =
            visibleCount > 0
              ? root.dataset.ready.replace('__COUNT__', visibleCount)
              : root.dataset.noResults;

          if (updateUrl && search) {
            const url = new URL(window.location.href);

            if (rawQuery) {
              url.searchParams.set('search', rawQuery);
            } else {
              url.searchParams.delete('search');
            }

            window.history.replaceState(
              window.history.state,
              '',
              `${url.pathname}${url.search}${url.hash}`
            );
          }

          syncCatalogBreadcrumb(rawQuery);
        };

        if (search) {
          search.disabled = false;
          search.addEventListener('input', () => applySearch(true));
        }

        applySearch();

        status.textContent = formatProgress(
          root.dataset.loadingNames,
          0,
          cardRecords.length
        );
        updateProgress(
          progressWrap,
          progress,
          progressLabel,
          root.dataset.loadingNames,
          0,
          cardRecords.length
        );

        await loadWithConcurrency(
          cardRecords,
          8,
          async (cardRecord) => {
            const details = await getDesignDetails(cardRecord.design.id);
            cardRecord.setDetails(details);
            applySearch();
            return details;
          },
          (cardIndex, details, completed) => {
            updateProgress(
              progressWrap,
              progress,
              progressLabel,
              root.dataset.loadingNames,
              completed,
              cardRecords.length
            );
          }
        );

        cardRecords.sort(compareCardsBySize);

        if (root.classList.contains('pitchprint-catalog--stamp-plates')) {
          applyRelativePlateScale(cardRecords);
        }

        grid.replaceChildren(...cardRecords.map((cardRecord) => cardRecord.article));
        progressWrap.hidden = true;
        status.hidden = false;

        applySearch();
      } catch (error) {
        console.warn('[PitchPrint catalog]', error);
        progressWrap.hidden = true;
        status.hidden = false;
        status.textContent = root.dataset.error;
      }
    };

    const initializeAll = () => {
      document
        .querySelectorAll('[data-pitchprint-template-catalog]')
        .forEach(initializeCatalog);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  // Look for an element with class 'related-products'
  var relatedProductsSection = document.querySelector('.related-products');
  if (relatedProductsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", relatedProductsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML;
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
